import {Provider} from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {EntryViewerViewModel} from '../../presentation/viewmodels/entry-viewer.viewmodel';
import {ENTRY_FORMATTING_PORT} from "../../../../../shared/domain/tokens/entry-formatting.token";
import {EntryFormattingService} from "../services/entry-formatting.service";

export const ENTRY_PROVIDERS: Provider[] = [
  CurrencyPipe,
  EntryViewerViewModel,
  {
    provide: ENTRY_FORMATTING_PORT,
    useClass: EntryFormattingService,
  }
];
